import React, {useCallback, useEffect, useMemo, useState} from 'react';
import useApi from "../../hooks/useApi";
import IProvince from "../../models/IProvince";
import {SelectBox} from "devextreme-react/select-box";
import IEditorOptions from "../../models/IEditorOptions";
import {useQuery} from "@tanstack/react-query";

;

function useProvince() {
    const {getData: getProvince} = useApi<IProvince[]>('province');
    const {data: provinces, refetch} = useQuery({queryKey: ['IProvince'], queryFn: () => getProvince()});
    const [currentSelectedItem, setCurrentSelectedItem] = useState<IProvince>();

    const editorOptions = useMemo((): IEditorOptions<IProvince[]> => {
        return {
            searchEnabled: true,
            dataSource: provinces,
            displayExpr: "description",
            displayValue: "idProvince",
            valueExpr: "idProvince",
        }
    }, [provinces])

    const ProvinceSelectBox = useCallback((params: any) => {
        const {dataField, component, column, data} = params;
        const formOptions = component?.option();
        const value = dataField ? formOptions.formData[dataField] : data ? data[column.dataField] : params.value;

        const onValueChanged = (args: any) => {
            setCurrentSelectedItem(provinces?.find(f => f.idProvince?.equals(args.value)));
        }

        const onSelectionChanged = (e: any) => {
            if (dataField)
                component?.updateData(dataField, e.selectedItem.idProvince);
            setCurrentSelectedItem(provinces?.find(f => f.idProvince?.equals(e.selectedItem.idProvince)));
        }

        return (
            <SelectBox readOnly={formOptions?.readOnly} onSelectionChanged={onSelectionChanged}
                       dataSource={editorOptions.dataSource} displayExpr={editorOptions.displayExpr}
                       displayValue={editorOptions.displayValue} valueExpr={editorOptions.valueExpr} value={value}
                       onValueChanged={onValueChanged}/>
        )
    }, [provinces, editorOptions.dataSource, editorOptions.displayExpr, editorOptions.displayValue, editorOptions.valueExpr]);

    return {
        provincesEditorOptions: editorOptions,
        provinces,
        currentProvince: currentSelectedItem,
        refreshData: () => refetch(),
        ProvinceSelectBox
    }
}

export default useProvince;

